import React from 'react';
import styled from 'styled-components';

import { Filter } from '@/typings/filter/types';
import RadioInput from '@/components/Input/RadioInput';

type Props = {
  field: Filter;
};

const Radio = ({ field }: Props) => {
  return (
    <Component>
      <RadioInput />
    </Component>
  );
};

export default Radio;

const Component = styled.div`
  position: relative;
`;
